module.exports = __webpack_public_path__ + "img/tu10.ca7ff0a2.png";